<template>
  <div class="NewsCenter flex  flex-wrap mt-80 nth3">
    <div style="cursor: pointer" :class="['NewsCenter-item', swidth > 768 ? 'w-31 mr-35p' : 'w-100']"
      v-for="item in items" :key="item.id">
      <img class="pic" :src="item.home_cover_img" :alt="item.title" @click="toDetailop(item)" />
      <p class="title fw-n">{{ item.title }}</p>
      <div class="date fw-n">
        <!-- <span class="day">{{ item }}</span> -->
        <span class="year-month">
          <i>{{ item.create_time.slice(0, 4) }}</i>
          <span class="year-month">
            / {{ item.create_time.slice(5, 10) }}</span>
        </span>
      </div>
      <div class="content ellipsis3">{{ item.desc }}</div>
    </div>
    <el-empty class="m-auto" description="暂无数据" :image-size="swidth > 768 ? 200 : 100"
      v-show="!items.length"></el-empty>
  </div>
</template>

<script>
// import { mapState } from "vuex";
export default {
  name: "NewsCenter",
  props: {
    ["items"]: { type: Array, default: () => [] },

    swidth: {
      type: Number
    }
  },
  computed: {
    // ...mapState("home", ["newsItem"]),
  },
  data() {
    return {
      defautlurl: 'https://external.333f.com/333f-2021-api/public/storage/'
    }
  },
  created() { },
  methods: {
    toDetailop(item) {
      if (item.type === 1) {
        this.$router.push({
          path: `news/${item.id}`,
          params: {
            id: item.id,
          },
        });
      } else {

        window.open(item.content);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.NewsCenter {
  // display: flex;
  // flex-wrap: wrap;
  // justify-content: space-between;

  &-item {
    // flex: 0 0 30%;
    // margin: 0 5px 30px;
    margin-bottom: 30px;
  }

  .pic {
    width: 100%;
    // height: 310px;
    margin-bottom: 20px;
  }

  .title {
    padding-bottom: 15px;
    font-size: 26px;
    color: @primaryColor;
  }

  .date {
    width: 100%;
    padding-bottom: 6px;
    color: @text-title-ZH-color;
    border-bottom: 1px solid @border-normal-color;
  }

  .day {
    font-size: 25px;
  }

  .year-month {
    font-family: Arial-BoldMT;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0.5px;
    color: #666666;

    i {
      font-size: 32px;
      font-style: normal;
      font-weight: 600;
    }
  }

  .ellipsis3 {
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;
    /* autoprefixer: off */
    -webkit-box-orient: vertical;
    color: #666666;
    margin-top: 4px;
    letter-spacing: 0.5px;
  }

}

.nth3 {
  .NewsCenter-item:nth-child(3n) {
    margin-right: 0;
  }

}
</style>
<!-- import { push } from "core-js/core/array"; -->



// WEBPACK FOOTER //
// src/components/NewsCenter.vue